import { render, staticRenderFns } from "./FaqSearchInput.vue?vue&type=template&id=122d509e&scoped=true&lang=pug&"
import script from "./FaqSearchInput.vue?vue&type=script&setup=true&lang=js&"
export * from "./FaqSearchInput.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./FaqSearchInput.scss?vue&type=style&index=0&id=122d509e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122d509e",
  null
  
)

export default component.exports